module.exports = __webpack_public_path__ + "img/143.c2a551ec.jpg";